import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NavigationService } from 'src/app/navigation/navigation.service';
import { MarketplaceService } from 'src/app/gamification/command-center/services/marketplace.service';
import { GamificationMainService } from 'src/app/gamification/command-center/services/gamification-main.service';

import { MarketplaceOrdersModalComponent } from '../../modals/marketplace-orders-modal/marketplace-orders-modal.component';
import { MarketplaceProductsModalComponent } from '../../modals/marketplace-products-modal/marketplace-products-modal.component';

@Component({
  selector: 'cv-marketplace-overview',
  templateUrl: './marketplace-overview.component.html',
  styleUrls: ['./marketplace-overview.component.scss']
})
export class MarketplaceOverviewComponent implements OnInit {
  ms = null;
  gms = null;

  constructor(
    private modalService: NgbModal,
    private navigationService: NavigationService,
    private marketplaceService: MarketplaceService,
    private gamificationMainService: GamificationMainService
  ) {
    this.ms = this.marketplaceService.data;
    this.gms = this.gamificationMainService.data;
  }

  ngOnInit(): void { }

  openOrders(type: string): void {
    this.navigationService.showOverlay = true;

    const modalRef = this.modalService.open(MarketplaceOrdersModalComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    if (type === 'processing')
      modalRef.componentInstance.items = this.ms.ordersByStatus[type];

    modalRef.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }

  openProducts(type: string): void {
    this.navigationService.showOverlay = true;

    const modalRef = this.modalService.open(MarketplaceProductsModalComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    modalRef.componentInstance.items = this.ms['products' + type];

    modalRef.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }
}